const localizers = {
  'loading.msg': () => `Wird geladen...`,
  'SASServer.genericError.msg': () => `Der Server ist nicht erreichbar.`,
  'SASReport.genericError.msg': () => `Der ausgewählte Bericht kann nicht geladen werden.`,
  'SASReportImage.genericError.msg': () => `Das Berichtsbild konnte nicht geladen werden.`,
  'SASReportImage.imageNotSupported.msg': () => `Bilder werden für diesen Berichtsinhaltstyp nicht unterstützt.`,
}
export default localizers;
